<template>
  <div>
    <admin-sidebar></admin-sidebar>
    <section id="dashboard">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 mb-30">
            <div class="title">
              <h2>perdoruesit</h2>
            </div>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <form class="user">
              <div class="white-background mb-30">
                <div class="title">
                  <h4>Shto përdorues të ri</h4>
                </div>
                <div class="form-group">
                  <input
                    type="text"
                    placeholder="emri dhe mbiemri"
                    :value="fullName"
                    @input="getFullName"
                  />
                  <input
                    type="email"
                    placeholder="email"
                    :value="email"
                    @input="getEmail"
                  />
                  <select
                    class="select-cars text-dark py-1 w-100"
                    :value="role"
                    @input="getRole"
                    required
                  >
                    <option class="text-dark" value disabled selected
                      >Pozita e perdoruesit</option
                    >
                    <option value="driver">Vozitës</option>
                    <option value="finances"
                      >Financa</option
                    >
                    <option value="operations"
                      >Operacione</option
                    >
                    <option value="finops"
                      >Financa dhe Operacione</option
                    >
                    <option value="superadmin"
                      >Super Admin</option
                    >
                  </select>
                </div>
              </div>
              <div>
                <p v-if="registerSuccess === true" class="text-success">
                  Perdoruesi u shtua me sukses.
                </p>
                <p v-if="registerSuccess === false" class="text-danger">
                  Nuk ka mundesi te krijohet perdorues i ri me te dhenat e
                  ofruara.
                </p>
              </div>
              <div class="confirmation">
                <div class="col-12 p-0 col-sm-5 col-md-4 col-lg-3">
                  <button class="btn-block px-sm-4" @click="requestAdminCreate">
                    Shto Përdoruesin
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="white-background">
              <div class="title">
                <h4>Përdoruesit aktual</h4>
              </div>
              <div class="padding-0 tab-style">
                <table class="table table-responsive-md">
                  <thead>
                    <tr>
                      <th>Shfrytezuesi</th>
                      <th>Tipi</th>
                      <th>Email</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="admin in adminList" :key="admin.email">
                      <th>{{ admin.full_name }}</th>
                      <th>{{ admin.user_type }}</th>
                      <th>{{ admin.email }}</th>
                      <th>
                        <button
                          style="color: #edc239;background: white;"
                          @click="removeAdmin(admin.id, $event)"
                        >
                          <i class="fas fa-trash-alt"></i>
                        </button>
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style src="@/assets/admin/css/main.css"></style>

<script>
import AdminSidebar from "@/components/admin/AdminSidebar";
import { mapGetters } from "vuex";

export default {
  name: "AdminUsers",
  components: {
    AdminSidebar: AdminSidebar,
  },
  methods: {
    getFullName(e) {
      this.$store.dispatch("users/getFullName", e.target.value);
    },
    getEmail(e) {
      this.$store.dispatch("users/getEmail", e.target.value);
    },
    getRole(e) {
      this.$store.dispatch("users/getRole", e.target.value);
    },
    requestAdminCreate(e) {
      e.preventDefault();
      this.$store.dispatch("users/requestAdminCreate");
    },
    removeAdmin(id, e) {
      e.preventDefault();
      this.$store.dispatch("users/removeAdmin", id);
    },
  },
  computed: {
    ...mapGetters({
      fullName: "users/fullName",
      email: "users/email",
      role: "users/role",
      registerSuccess: "users/registerSuccess",
      adminList: "users/adminList",
    }),
  },
  beforeMount() {
    this.$store.dispatch("users/getAdminList");
  },
};
</script>
